import React from 'react';
import { VideoDescriptionDecorated } from '..';
import { VideoMetadata } from './video-metadata';
import { RateVideo } from '../rate-video';

export const VideoInfo = ({ video, withRating, inlineVideoControls, pageNumber, sort }) => {
  return (
    <div className="ct-video-info" data-e2e={'ct-video-info'}>
      <div className="ct-video-info__header">
        <h3 className="ct-video-info__title" data-e2e={'ct-video-info_title'}>
          {video.title}
        </h3>
        {withRating && (
          <div className="ct-video-info__rating" data-e2e="rating-desktop">
            <RateVideo />
          </div>
        )}
      </div>
      <div className="ct-video-info__extras">
        <div className="ct-video-info__metadata">
          <VideoMetadata video={video} />
        </div>
        {inlineVideoControls && (
          <div className="ct-video-info__share-options" data-e2e="video-share-options">
            {inlineVideoControls({ video, pageNumber, sort })}
          </div>
        )}
      </div>
      {withRating && (
        <div className="ct-video-info-mobile__rating" data-e2e="rating-mobile">
          <RateVideo />
        </div>
      )}
      <VideoDescriptionDecorated description={video.description} />
    </div>
  );
};
